export class User {
  userId: number;
  avatar?: any;
  isAccountActivated: boolean;
  subscriberId: number;
  relationshipCode?: any;
  passwordHash?: any;
  email: string;
  phoneNumber?: any;
  userName?: any;
  accountId?: any;
  hasAcceptedTerms: boolean;
  clientId?: any;
  dateOfBirth?: any;
  gender?: any;
  firstName: string;
  middleName?: any;
  lastName: string;
  address1: string;
  address2?: any;
  city: string;
  state: string;
  zipCode: string;
  externalUserId?: any;
  fromImport: boolean;
  agreedTerms: boolean;
  isLocked: boolean;
  timezone?: any;
  preferredLanguage?: any;
  preferredGender?: any;
  providerName?: string;
  contactPhoneNumber?: any;
  providerType: string;
  doseSpotPatientId: number;
  isSubscriber: boolean;
}

export class ChartFile {
  fileId: number;
  fileUrl: string;
  fileExtension: string;
  fileName: string;
}

export class RetrySMS {
  messageId?: number;
  providerName: string;
  providerPhone: string;
  userID: number;
  messageDataFrom: TwilioSMS[];
  messageDataTo: TwilioSMS[];
  messageSequence: TwilioSMS[];
  messageDataToOrg: TwilioSMS[];
  newMsgs?: boolean;
  msgCount?: number;
}

export class TwilioSMS {
  hasBeenRead?: boolean;
  account_sid: string;
  api_version: string;
  body: string;
  date_created: Date;
  date_sent: Date;
  date_updated: Date;
  direction: string;
  error_code: string;
  error_message: string;
  from: string;
  messaging_service_sid: string;
  num_media: string;
  num_segments: string;
  price: string;
  price_unit: string;
  senderName: string;
  sid: string;
  status: string;
  subresource_uris: {};
  to: string;
  uri: string;
}

export class VideoSession {
  sessionId: string;
  videoToken: string;
  isActive: boolean;
}
